export const apiList = [
  {
    id: '1',
    description: 'Eligibility and Benefits Checks',
    code: 'EBC',
    selected: false,
  },
  {
    id: '2',
    description: 'Claims and Payment Management',
    code: 'CPM',
    selected: false,
  },
  {
    id: '3',
    description: 'Referrals',
    code: 'RFR',
    selected: false,
  },
  {
    id: '4',
    description: 'Provider Access API',
    code: 'PAC',
    selected: false,
  },
];

export const apiListV2 = [
  {
    id: '1',
    description: 'Eligibility and Benefits Checks',
    code: 'EBC',
    selected: false,
    label: 'Eligibility and Benefits Checks',
    value: 'EBC',
  },
  {
    id: '2',
    description: 'Claims and Payment Management',
    code: 'CPM',
    selected: false,
    label: 'Claims and Payment Management',
    value: 'CPM',
  },
  {
    id: '3',
    description: 'Referrals',
    code: 'RFR',
    selected: false,
    label: 'Referrals',
    value: 'RFR',
  },
  {
    id: '4',
    description: 'Provider Demographic',
    code: 'DMG',
    selected: false,
    label: 'Provider Demographic',
    value: 'DMG',
  },
  {
    id: '5',
    description: 'Prior Authorizations',
    code: 'PRA',
    selected: false,
    label: 'Prior Authorizations',
    value: 'PRA',
  },
  {
    id: '6',
    description: 'Provider Access API',
    code: 'PAC',
    selected: false,
    label: 'Provider Access API',
    value: 'PAC',
  },
  {
    id: '7',
    description: 'TrackIt',
    code: 'TRI',
    selected: false,
    label: 'TrackIt',
    value: 'TRI',
  },
  {
    id: '8',
    description: 'Dental',
    code: 'DEN',
    selected: false,
    label: 'Dental',
    value: 'DEN',
  },
];

export const superConnectorApis = [
  {
    value: 'SCEP',
    label: 'Member Eligibility Check',
    description: 'Member Eligibility Check',
    code: 'SCEP',
  },
  {
    value: 'SCCP',
    label: 'Claim Precheck',
    description: 'Claim Precheck',
    code: 'SCCP',
  },
  {
    value: 'SCCA',
    label: 'Claim Actions',
    description: 'Claim Actions',
    code: 'SCCA',
  },
  {
    value: 'SCBC',
    label: 'Benefits Check',
    description: 'Benefits Check',
    code: 'SCBC',
  },
  {
    value: 'SCCI',
    label: 'Claim Status Inquiry',
    description: 'Claim Status Inquiry',
    code: 'SCCI',
  },
];

export const SCPAR = {
  value: 'SCPAR',
  label: 'Prior Auth and Referral Actions',
  description: 'Prior Auth and Referral Actions',
  code: 'SCPAR',
};

export const SCDS = {
  value: 'SCDS',
  label: 'Document Search',
  description: 'Document Search',
  code: 'SCDS',
};
